import { RootState } from '../../../app/store';
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit"
import CareModel from '../models/CareModel';

interface CareInputState {
    input: CareModel,
    selectedCareId: string,
    selectedClientId: string,
    CareInputExpand: boolean,
    triggerFocusCompanyNameInput: number,
    triggerSave: number,
    triggerRefreshInput: number,
    accounts: string[],
    showCareDetail: boolean
}

const initialState: CareInputState = {
    input: {
        year: new Date().getFullYear(),
        clientId: "",
        careId: "",
        clientName: "",
        country: "",
        city: "",
        address: "",
        picname: "",
        sex: null,
        picBirthday: "",
        phone: "",
        hobby: "",
        brokersTakeCare: "",
        newYear: 0,
        midAutumn: 0,
        companyAnniversary: 0,
        birthday: 0,
        womenDay: 0,
        promotion: 0,
        newBaby: 0,
        funeral: 0,
    } as unknown as CareModel,
    selectedCareId: "",
    selectedClientId: "",
    CareInputExpand: true,
    triggerFocusCompanyNameInput: 0,
    triggerSave: 0,
    triggerRefreshInput: 0,
    accounts: [],
    showCareDetail: false
}

export const CareInputSlice = createSlice({
    name: "CareInput",
    initialState,
    reducers: {
        setCareYear: (state, action: PayloadAction<number>) => {
            state.input.year = action.payload;
        },
        setCareClientId: (state, action: PayloadAction<string>) => {
            state.input.clientId = action.payload;
        },
        setCareClientName: (state, action: PayloadAction<string>) => {
            state.input.clientName = action.payload;
        },
        setCareInput: (state, action: PayloadAction<CareModel>) => {
            state.input = action.payload;
        },
        setCountry: (state, action: PayloadAction<string>) => {
            state.input.country = action.payload;
        },
        setCity: (state, action: PayloadAction<string>) => {
            state.input.city = action.payload;
        },
        setAddress: (state, action: PayloadAction<string>) => {
            state.input.address = action.payload;
        },
        setPicname: (state, action: PayloadAction<string>) => {
            state.input.picname = action.payload;
        },
        setSex: (state, action: PayloadAction<boolean>) => {
            state.input.sex = action.payload;
        },
        setPicbirthday: (state, action: PayloadAction<string>) => {
            state.input.picBirthday = action.payload;
        },
        setPhone: (state, action: PayloadAction<string>) => {
            state.input.phone = action.payload;
        },
        setHobby: (state, action: PayloadAction<string>) => {
            state.input.hobby = action.payload;
        },
        setBrokersTakeCare: (state, action: PayloadAction<string>) => {
            state.input.brokersTakeCare = action.payload;
        },
        setNewYear: (state, action: PayloadAction<number>) => {
            state.input.newYear = action.payload;
        },
        setMidAutumn: (state, action: PayloadAction<number>) => {
            state.input.midAutumn = action.payload;
        },
        setCompanyAnniversary: (state, action: PayloadAction<number>) => {
            state.input.companyAnniversary = action.payload;
        },
        setBirthday: (state, action: PayloadAction<number>) => {
            state.input.birthday = action.payload;
        },
        setWomenDay: (state, action: PayloadAction<number>) => {
            state.input.womenDay = action.payload;
        },
        setPromotion: (state, action: PayloadAction<number>) => {
            state.input.promotion = action.payload;
        },
        setNewBaby: (state, action: PayloadAction<number>) => {
            state.input.newBaby = action.payload;
        },
        setFuneral: (state, action: PayloadAction<number>) => {
            state.input.funeral = action.payload;
        },
        setSelectedCareId: (state, action: PayloadAction<string>) => {
            state.selectedCareId = action.payload;
        },
        setSelectedClientId: (state, action: PayloadAction<string>) => {
            state.selectedClientId = action.payload;
        },
        setCareInputExpand: (state, action: PayloadAction<boolean>) => {
            state.CareInputExpand = action.payload;
        },
        setTriggerFocusCompanyNameInput: (state, action: PayloadAction<number>) => {
            state.triggerFocusCompanyNameInput = action.payload;
        },
        resetCareInput: (state) => {
            state.input = initialState.input;
        },
        setTriggerSave: (state, action: PayloadAction<number>) => {
            state.triggerSave = action.payload;
        },
        setTriggerRefreshInput: (state, action: PayloadAction<number>) => {
            state.triggerRefreshInput = action.payload;
        },
        setAccounts: (state, action: PayloadAction<string[]>) => {
            state.accounts = action.payload;
        },
        setShowCareDetail: (state, action: PayloadAction<boolean>) => {
            state.showCareDetail = action.payload;
        },
    }
});

export const CareInputSelector = createSelector(
    (state: RootState) => state.careInput,
    (data) => data
);

export const {
    setCareYear,
    setCareClientId,
    setCareClientName,
    setCareInput,
    setCountry,
    setCity,
    setAddress,
    setPicname,
    setSex,
    setPicbirthday,
    setPhone,
    setHobby,
    setBrokersTakeCare,
    setNewYear,
    setMidAutumn,
    setCompanyAnniversary,
    setBirthday,
    setPromotion,
    setWomenDay,
    setNewBaby,
    setFuneral,
    setSelectedCareId,
    setSelectedClientId,
    setCareInputExpand,
    setTriggerFocusCompanyNameInput,
    resetCareInput,
    setTriggerSave,
    setTriggerRefreshInput,
    setAccounts,
    setShowCareDetail
} = CareInputSlice.actions;

export default CareInputSlice.reducer;